import React, { FC } from 'react';

import {
  TableContainer, Table, TableHead, TableRow, TableCell,
  TableBody, makeStyles, Button,
} from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf, faCloudDownloadAlt } from '@fortawesome/free-solid-svg-icons';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

interface CatalogListProps {
  catalogLogItems: any[],
  onOpen: (url: string) => void,
  onDownload: (url: string) => void,
}

const CatalogList: FC<CatalogListProps> = (props) => {
  const classes = useStyles();
  const { catalogLogItems, onOpen, onDownload } = props;

  return (
    <TableContainer>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Catalog</TableCell>
            <TableCell>Pricesheet</TableCell>
            <TableCell>Generated On</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {catalogLogItems?.map((logItem: any, index1: number) => (
            <TableRow key={index1}>
              <TableCell component="th" scope="row">
                {logItem.catalogSpecLabel}
              </TableCell>
              <TableCell>
                {logItem.pricesheetLabel}
              </TableCell>
              <TableCell>
                {logItem.generatedOn}
              </TableCell>
              <TableCell>
                <Button
                  onClick={() => {
                    onOpen(logItem.generatedUrl);
                  }}
                >
                  <FontAwesomeIcon icon={faFilePdf} />
                </Button>
                <Button
                  onClick={() => {
                    onDownload(logItem.generatedUrl);
                  }}
                >
                  <FontAwesomeIcon icon={faCloudDownloadAlt} />
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CatalogList;
